import { IsNotEmpty, IsUUID, IsOptional, IsArray } from 'class-validator';

import { GetAccountUsersGroupsQueryDto } from './get-account-users-groups-query.dto';

export class EditAccountUserGroupsDto {
  @IsUUID()
  @IsNotEmpty()
  accountId: string;

  @IsUUID()
  @IsNotEmpty()
  userId: string;

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsNotEmpty()
  userGroups: string[];

  @IsOptional()
  filter?: GetAccountUsersGroupsQueryDto;
}
